import type {CookieConsent} from 'src/app/modules/auth/cookie-consent/types'

export type {CookieConsent}

export const COOKIE_CONSENT_KEY = 'cookie-consent'

export const defaultCookieConsent: CookieConsent = {
  necessary: true,
  analytics: false,
  preferences: false,
  marketing: false,
  banner_hidden: false,
}

export const readCookieConsent = (): CookieConsent | null => {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY)
    return raw ? JSON.parse(raw) as CookieConsent : null
  } catch {
    return null
  }
}

export const saveCookieConsent = (consent: CookieConsent) => {
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent))
  window.dispatchEvent(new Event('cookie-consent-changed'))
}

export const clearCookieConsent = () => {
  localStorage.removeItem(COOKIE_CONSENT_KEY)
}
